// Generated by purs version 0.15.15
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Generic from "../Data.Argonaut.Decode.Generic/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Argonaut_Encode_Generic from "../Data.Argonaut.Encode.Generic/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as MST_Data_BasicURL from "../MST.Data.BasicURL/index.js";
import * as MST_Encoding from "../MST.Encoding/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(MST_Data_BasicURL.showBasicURL))(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString)));
var FSWarningDownloadStreamFailedIsSymbol = {
    reflectSymbol: function () {
        return "FSWarningDownloadStreamFailed";
    }
};
var FSWarningUploadStreamFailedIsSymbol = {
    reflectSymbol: function () {
        return "FSWarningUploadStreamFailed";
    }
};
var eq = /* #__PURE__ */ Data_Eq.eq(MST_Data_BasicURL.eqBasicURL);
var encodeRepArgsProduct = /* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsProduct(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(MST_Data_BasicURL.encodeJsonBasicURL))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepArgsArgument(Data_Argonaut_Encode_Class.encodeJsonJString));
var decodeRepArgsProduct = /* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepArgsProduct(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepArgsArgument(MST_Data_BasicURL.decodeJsonBasicURL))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepArgsArgument(Data_Argonaut_Decode_Class.decodeJsonString));
var FSWarningDownloadStreamFailed = /* #__PURE__ */ (function () {
    function FSWarningDownloadStreamFailed(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    FSWarningDownloadStreamFailed.create = function (value0) {
        return function (value1) {
            return new FSWarningDownloadStreamFailed(value0, value1);
        };
    };
    return FSWarningDownloadStreamFailed;
})();
var FSWarningUploadStreamFailed = /* #__PURE__ */ (function () {
    function FSWarningUploadStreamFailed(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    FSWarningUploadStreamFailed.create = function (value0) {
        return function (value1) {
            return new FSWarningUploadStreamFailed(value0, value1);
        };
    };
    return FSWarningUploadStreamFailed;
})();
var genericFSWarning_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new FSWarningDownloadStreamFailed(x.value0.value0, x.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new FSWarningUploadStreamFailed(x.value0.value0, x.value0.value1);
        };
        throw new Error("Failed pattern match at Fusion.Data.FSWarning (line 16, column 1 - line 16, column 36): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof FSWarningDownloadStreamFailed) {
            return new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1));
        };
        if (x instanceof FSWarningUploadStreamFailed) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Product(x.value0, x.value1));
        };
        throw new Error("Failed pattern match at Fusion.Data.FSWarning (line 16, column 1 - line 16, column 36): " + [ x.constructor.name ]);
    }
};
var showFSWarning = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericFSWarning_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(FSWarningDownloadStreamFailedIsSymbol))(/* #__PURE__ */ genericShowConstructor(FSWarningUploadStreamFailedIsSymbol)))
};
var eqFSWarning = {
    eq: function (x) {
        return function (y) {
            if (x instanceof FSWarningDownloadStreamFailed && y instanceof FSWarningDownloadStreamFailed) {
                return eq(x.value0)(y.value0) && x.value1 === y.value1;
            };
            if (x instanceof FSWarningUploadStreamFailed && y instanceof FSWarningUploadStreamFailed) {
                return eq(x.value0)(y.value0) && x.value1 === y.value1;
            };
            return false;
        };
    }
};
var encodeJsonFSWarning = {
    encodeJson: /* #__PURE__ */ MST_Encoding.genericEncodeJsonVisonum(genericFSWarning_)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(FSWarningDownloadStreamFailedIsSymbol)(encodeRepArgsProduct))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(FSWarningUploadStreamFailedIsSymbol)(encodeRepArgsProduct)))
};
var decodeJsonFSWarning = {
    decodeJson: /* #__PURE__ */ MST_Encoding.genericDecodeJsonVisonum(genericFSWarning_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructor(FSWarningDownloadStreamFailedIsSymbol)(decodeRepArgsProduct))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructor(FSWarningUploadStreamFailedIsSymbol)(decodeRepArgsProduct)))
};
export {
    FSWarningDownloadStreamFailed,
    FSWarningUploadStreamFailed,
    genericFSWarning_,
    showFSWarning,
    eqFSWarning,
    encodeJsonFSWarning,
    decodeJsonFSWarning
};
